import React from "react";
import { useUserProfile } from "../../../contexts/UserProfileContext";
import PublicUserProfile from "../sections/PublicUserProfile";
import SetupPage from "../sections/SetupPage";

const UserProfileSetupTab = () => {
  const { isOwnProfile, publicProfileProps } = useUserProfile();
  if (isOwnProfile) return <SetupPage />;
  if (!publicProfileProps) return null;
  return <PublicUserProfile {...publicProfileProps} activeSection="setup" />;
};

export default UserProfileSetupTab;
